import React, { useEffect, useState } from "react";
import { CustomDataTable } from "../../../components/CommnTable/CustomDataTable";
import usePaymentHistory from "./useFundViewPayment";
import { FundsPaymentInterface } from "../../../types/types";
import {
  Card,
  Box,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
// import styles from "./FundViewPayment.module.scss";
import styles from "../../ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails.module.scss";
import FormGenerator from "../../../components/FormBuilder/FormBuilder";
import {
  FundAddPaymentForm,
  FundEditPaymentForm,
} from "../../../types/formTypes";

const FundViewPayment = () => {
  const {
    columns,
    userData,
    data,
    fundDetail,
    HandlePagination,
    limitValue,
    editState,
    setEditState,
    editRowData,
    fundsFormFields,
    handleOnSubmit,
  } = usePaymentHistory();
  // const { fundsFormFields, handleOnSubmit  } = useUpdatePayment()
  const [viewDocModalOpen, setViewDocModalOpen] = useState<boolean>(false);
  console.log('fundsFormFields', fundsFormFields)
  const handleSuccessModalClose = () => {
    setViewDocModalOpen(false);
    setEditState(false);
  };
  useEffect(() => {
    if (editState === true) {
      setViewDocModalOpen(true);
    } else {
      setViewDocModalOpen(false);
    }
  }, [editState]);

  return (
    <Card
      style={{
        padding: "1rem",
        border: 0,
        boxShadow: "none",
        background: "none",
      }}
    >
      <Box className={"cardBoxUI cardBoxOtherUI"}>
        <Box className={styles.header}>
          <Box className={styles.navigationButtons}>
            <Typography variant="h6">Applicant Name</Typography>
            {
              <Chip
                label={`${fundDetail?.name || userData.full_name} ${
                  fundDetail?.course ? `(${fundDetail.course})` : ""
                }`}
                color="info"
                sx={{ fontSize: 16 }}
              />
            }
          </Box>
          <Box className={styles.navigationButtons}>
            <Typography variant="h6">Scholarship ID</Typography>
            {
              <Chip
                label={fundDetail?.scholarship_id || userData.scholarship_name}
                color="success"
                sx={{ fontSize: 16 }}
              />
            }
          </Box>
        </Box>
        <CustomDataTable<FundsPaymentInterface>
          data={data}
          columns={columns}
          tableTitle="Student Payment History"
          rowsPerPage={limitValue}
          onPageChange={(e: any) => HandlePagination(e)}
          exportCSVShow={false}
          exportExcelShow={true}
        />
      </Box>
      <Dialog
        open={viewDocModalOpen}
        onClose={handleSuccessModalClose}
        PaperProps={{
          sx: {
            width: "76rem",
            maxWidth: "90%",
          },
        }}
      >
        <DialogTitle>
          <Box display="flex" alignItems="flex-start" gap={2} flexDirection={'column'} borderBottom={1} borderColor={'divider'} paddingBottom={3} marginBottom={3}>
            <Box display="flex" flex={1} width={'100%'} alignItems="center" justifyContent={'center'} gap={1}>
              <Typography variant="h6" color="textSecondary">Student Payment Edit</Typography>
            </Box>
            <Box className={styles.navigationButtons} flex={1} display="flex" alignItems="center" gap={1}>
            <Typography variant="h6">Applicant Name</Typography>
            {
              <Chip
                label={`${fundDetail?.name || userData.full_name} ${
                  fundDetail?.course ? `(${fundDetail.course})` : ""
                }`}
                color="info"
                sx={{ fontSize: 16 }}
              />
            }
          </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <FormGenerator<FundEditPaymentForm>
            fields={fundsFormFields}
            onSubmit={(data: any) => handleOnSubmit(data)}
            direction="column"
          />
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <Button
            onClick={handleSuccessModalClose}
            variant="contained"
            color="info"
            className={styles.commonButton}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default FundViewPayment;
